import { render, staticRenderFns } from "./cancellationRecord.vue?vue&type=template&id=bf570388&scoped=true&"
import script from "./cancellationRecord.vue?vue&type=script&lang=js&"
export * from "./cancellationRecord.vue?vue&type=script&lang=js&"
import style0 from "./cancellationRecord.vue?vue&type=style&index=0&id=bf570388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf570388",
  null
  
)

export default component.exports